
// import React, { useState,useEffect } from "react";
// import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
// import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
// import FileUploader from "../../../components/Elements/FileUploader/FileUploader";
// import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
// import { putApi } from "../../../api/api_instance";
// import { API_URLS } from "../../../api/apiUrls";





// const UploadNewReport = ({ open, onCancel, reportId, selectedReport, onUploadSuccess }) => {
//   const [uploadedFiles, setUploadedFiles] = useState([]);
//   const [loading, setLoading] = useState(false);

//   console.log("Selected Report:", selectedReport);
//   console.log("Uploaded Files:", uploadedFiles);
//   useEffect(() => {
//     if (open) {
//       setUploadedFiles([]);
//       setLoading(false);
//     }
//   }, [open]);
//   // ✅ Upload function
//   const handleUpload = async () => {
//     if (!uploadedFiles.length) {
//       alert("Please select a file first!");
//       return;
//     }

//     if (!reportId || !selectedReport?._id) {
//       alert("Missing report ID or file ID!");
//       return;
//     }

//     setLoading(true);

//     try {
//       const formData = new FormData();

//       // Get the first file (assuming single file upload)
//       const fileItem = uploadedFiles[0];
//       let realFile = null;

//       // Extract the actual File object
//       if (fileItem?.originFileObj) {
//         realFile = fileItem.originFileObj;
//       } else if (fileItem instanceof File) {
//         realFile = fileItem;
//       } else if (fileItem?.file?.originFileObj) {
//         realFile = fileItem.file.originFileObj;
//       } else if (fileItem?.file instanceof File) {
//         realFile = fileItem.file;
//       }

//       if (!realFile) {
//         console.error("Could not extract file from:", fileItem);
//         alert("Invalid file format. Please try again.");
//         setLoading(false);
//         return;
//       }

//       console.log("Real File object:", realFile);
//       console.log("File name:", realFile.name);
//       console.log("File size:", realFile.size);
//       console.log("File type:", realFile.type);

//       // Append the file to FormData
//       formData.append("pdf", realFile, realFile.name);

//       // Log FormData contents
//       for (let pair of formData.entries()) {
//         console.log(pair[0], pair[1]);
//       }

//       // ✅ Call API
//       const res = await putApi({
//         apiUrl: API_URLS.UPLOAD_REPORT_REQUEST(reportId, selectedReport._id),
//         data: formData,
//         // Don't set Content-Type - browser will set it with boundary
//       });

//       if (res?.success) {
//         alert("✅ Report uploaded successfully!");
//         setUploadedFiles([]); // Clear files
//        if (onUploadSuccess) {
//           await onUploadSuccess(); // Wait for refresh to complete
//         }
//         onCancel();
//       } else {
//         alert(res?.message || "❌ Upload failed!");
//       }
//     } catch (error) {
//       console.error("Upload error:", error);

//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <DailogBox open={open} onCancel={onCancel} width={700}>
//       <div className="flex items-center gap-2 text-xl font-bold">
//         <TextStyles color="gradient">Upload New Report</TextStyles>
//       </div>

//       <div className="border border-solid border-grey-500 rounded-lg mt-4">
//         <FileUploader 
//           files={uploadedFiles} 
//           setFiles={setUploadedFiles}
//           maxCount={1} // Allow only one file
//           accept=".pdf" // Accept only PDF files
//         />
//       </div>

//       {/* Debug info */}
//       {uploadedFiles.length > 0 && (
//         <div className="mt-2 text-sm text-gray-600">
//           Selected file: {uploadedFiles[0]?.name || uploadedFiles[0]?.originFileObj?.name || "Unknown"}
//         </div>
//       )}

//       <div className="flex justify-center gap-6 p-5">
//         <CustomButton
//           buttonType="button"
//           variant="cancel"
//           buttonText="Cancel"
//           onClick={onCancel}
//           disabled={loading}
//           className="text-base font-normal h-[50px] px-8"
//         />

//         <CustomButton
//           buttonType="button"
//           variant="ok"
//           buttonText={loading ? "Uploading..." : "Send for Approval"}
//           onClick={handleUpload}
//           disabled={loading || uploadedFiles.length === 0}
//           className="text-base font-normal h-[50px] px-8"
//         />
//       </div>
//     </DailogBox>
//   );
// };

// export default UploadNewReport;




import React, { useState, useEffect } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import FileUploader from "../../../components/Elements/FileUploader/FileUploader";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { putApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const UploadNewReport = ({ open, onCancel, reportId, selectedReport, onUploadSuccess }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  console.log(selectedReport._id, "selectedReport._id")
  console.log("Selected Report:", selectedReport);
  console.log("Report ID:", reportId);
  console.log("Uploaded Files:", uploadedFiles);

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, duration);
  };

  useEffect(() => {
    if (open) {
      setUploadedFiles([]);
      setLoading(false);
    }
  }, [open]);

  // ✅ Extract real file object from various formats
  const extractRealFile = (fileItem) => {
    if (fileItem instanceof File) {
      return fileItem;
    }
    if (fileItem?.originFileObj instanceof File) {
      return fileItem.originFileObj;
    }
    if (fileItem?.file instanceof File) {
      return fileItem.file;
    }
    if (fileItem?.file?.originFileObj instanceof File) {
      return fileItem.file.originFileObj;
    }
    return null;
  };

  // ✅ Upload function
  const handleUpload = async () => {
    // Validation
    if (!uploadedFiles.length) {
      triggerPopup(
        "warning",
        "Missing Fields",
        "Please select a file first!"
      );
      return;
    }

    if (!reportId) {
      console.error("reportId is missing:", reportId);
      triggerPopup("error", "Error", "Missing report ID!");
      return;
    }

    if (!selectedReport?._id) {
      console.error("selectedReport._id is missing:", selectedReport);
      triggerPopup("error", "Error", "Missing selected report ID!");
      return;
    }

    setLoading(true);

    try {
      // Extract the real file object
      const fileItem = uploadedFiles[0];
      const realFile = extractRealFile(fileItem);

      if (!realFile) {
        console.error("Could not extract file from:", fileItem);
        console.error("File item structure:", JSON.stringify(fileItem, null, 2));
        triggerPopup(
          "warning",
          "Invalid File",
          "Invalid file format. Please try again"
        );
        setLoading(false);
        return;
      }

      // Validate it's a PDF
      if (realFile.type !== 'application/pdf') {
        triggerPopup("warning", "Invalid File Type", "Please upload a PDF file only!");
        setLoading(false);
        return;
      }

      console.log("✅ Real File object:", realFile);
      console.log("File name:", realFile.name);
      console.log("File size:", realFile.size, "bytes");
      console.log("File type:", realFile.type);

      // Create FormData
      const formData = new FormData();
      formData.append("pdf", realFile, realFile.name);

      // Log FormData contents for debugging
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0], ":", pair[1]);
      }

      // Construct API URL
      const apiUrl = API_URLS.UPLOAD_REPORT_REQUEST(reportId, selectedReport._id);
      console.log("API URL:", apiUrl);

      // ✅ Call API
      const res = await putApi({
        apiUrl: apiUrl,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log("API Response:", res);

      if (res?.success) {
        // Show success popup
        triggerPopup("success", "Upload Successful", "Report uploaded successfully!");

        // Clear files
        setUploadedFiles([]);

        // Wait for popup to show, then close modal and refresh
        setTimeout(async () => {
          if (onUploadSuccess) {
            await onUploadSuccess(); // Refresh parent data
          }
          onCancel(); // Close modal
        }, 2500);

      } else {
        triggerPopup(
          "error",
          "Upload Failed",
          res?.message || "Upload failed. Please try again."
        );
        console.error("Upload failed:", res);
      }
    } catch (error) {
      console.error("Upload error:", error);
      console.error("Error details:", error.response || error.message);
      triggerPopup(
        "error",
        "Upload Error",
        error.message || "Unknown error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <DailogBox open={open} onCancel={onCancel} width={700}>
        <div className="flex items-center gap-2 text-xl font-bold mb-4">
          <TextStyles color="gradient">Upload New Report</TextStyles>
        </div>

        <div className="border border-solid border-grey-500 rounded-lg">
          <FileUploader
            files={uploadedFiles}
            setFiles={setUploadedFiles}
            maxCount={1}
            accept=".pdf"
          />
        </div>

        {uploadedFiles.length > 0 && (
          <div className="mt-3 text-sm text-gray-600">
            Selected:{" "}
            {uploadedFiles[0]?.name ||
              uploadedFiles[0]?.originFileObj?.name ||
              uploadedFiles[0]?.file?.name ||
              "Unknown file"}
          </div>
        )}

        {/* ✅ Buttons */}
        <div className="flex justify-center gap-6 p-5">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={onCancel}
            disabled={loading}
            className="text-base font-normal h-[50px] px-8"
          />

          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText={loading ? "Uploading..." : "Send for Approval"}
            onClick={handleUpload}
            disabled={loading || uploadedFiles.length === 0}
            className="text-base font-normal h-[50px] px-8"
          />
        </div>

        {/* ✅ Success Popup inside Dialog */}
        {showPopup && (
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 rounded-lg">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DailogBox>
    </div>
  );

};

export default UploadNewReport;